import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import trackConfidence from "@/assets/track-confidence.png";
import trackExploration from "@/assets/track-exploration.png";
import trackFirstSex from "@/assets/track-first-sex.png";
import trackPleasure from "@/assets/track-pleasure.png";
const tracks = [
    {
        img: trackConfidence,
        title: "Confidence",
        desc: "Build unshakeable self-assurance in intimate situations",
        delay: "0s",
    },
    {
        img: trackExploration,
        title: "Exploration of Desires",
        desc: "Map the full landscape of what excites you",
        delay: "0.1s",
    },
    {
        img: trackFirstSex,
        title: "First Time with a New Partner",
        desc: "Ease anxiety and be fully present from the very start",
        delay: "0.2s",
    },
    {
        img: trackPleasure,
        title: "Pleasure Fantasies",
        desc: "Deepen your imagination and broaden your experience",
        delay: "0.3s",
    },
];
const AppTracksSection = () => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) {
            setVisible(true);
            observer.disconnect();
        } }, { threshold: 0.1 });
        if (ref.current)
            observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);
    return (_jsx("section", { className: "py-24 md:py-32 bg-section-alt", children: _jsxs("div", { className: "container mx-auto px-6", ref: ref, children: [_jsxs("div", { className: "text-center mb-16", style: {
                        opacity: visible ? 1 : 0,
                        transform: visible ? "translateY(0)" : "translateY(20px)",
                        filter: visible ? "blur(0)" : "blur(4px)",
                        transition: "opacity 0.7s cubic-bezier(0.16,1,0.3,1), transform 0.7s cubic-bezier(0.16,1,0.3,1), filter 0.7s cubic-bezier(0.16,1,0.3,1)",
                    }, children: [_jsx("p", { className: "uppercase tracking-[0.25em] text-sm font-semibold mb-5 text-brand-gradient", children: "Inside Rino" }), _jsxs("h2", { className: "font-sans font-black text-foreground text-4xl md:text-5xl", children: ["Audio tracks crafted", _jsx("br", {}), "for every experience"] })] }), _jsx("div", { className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto", children: tracks.map((track) => (_jsxs("div", { className: "bg-surface-raised border border-border rounded-2xl overflow-hidden", style: {
                            opacity: visible ? 1 : 0,
                            transform: visible ? "translateY(0)" : "translateY(28px)",
                            transition: `opacity 0.7s cubic-bezier(0.16,1,0.3,1) ${track.delay}, transform 0.7s cubic-bezier(0.16,1,0.3,1) ${track.delay}`,
                            boxShadow: "0 4px 24px hsl(242 20% 4% / 0.5)",
                        }, children: [_jsx("div", { className: "relative h-48 bg-background flex items-center justify-center p-6", children: _jsx("img", { src: track.img, alt: track.title, className: "w-full h-full object-contain", loading: "lazy" }) }), _jsxs("div", { className: "p-5", children: [_jsx("h3", { className: "font-sans font-bold text-foreground text-base mb-1.5 leading-snug", children: track.title }), _jsx("p", { className: "text-foreground/50 text-sm leading-relaxed", children: track.desc })] })] }, track.title))) }), _jsx("div", { className: "text-center mt-10", style: {
                        opacity: visible ? 1 : 0,
                        transition: "opacity 0.7s cubic-bezier(0.16,1,0.3,1) 0.4s",
                    }, children: _jsx("p", { className: "text-foreground/40 text-sm font-medium tracking-wide", children: "+ 50 more tracks inside the app" }) })] }) }));
};
export default AppTracksSection;
